import React, { useMemo } from 'react';
import { Box } from '@common-fe/common-fe';
import styled from 'styled-components';

import regexp from '@/common/regexp';

import { Change } from './queries/useSearchChangesetChanges.query';
import { ChangeSetLogItem } from './ChangeSetLogItem';

const ChangeSetWrapper = styled(Box)`
  > div:not(:last-child) {
    border-bottom: 1px solid ${({ theme }) => theme.colors.border1};
  }
`;

interface Props {
  logs: Change[];
  isBulkUpdate?: boolean;
}

export const ChangeSetLogs: React.FC<Props> = ({ logs, isBulkUpdate }) => {
  const { employeeName, planName, uniqueGroupId } = useMemo(() => logs?.find((item) => item?.uniqueGroupId) || {}, [logs]);

  return (
    <ChangeSetWrapper
      margin={{ top: 'spacing8' }}
      background="canvas"
      border={{ size: '1px', color: 'border2' }}
      round="xsmall"
      data-testId={uniqueGroupId}
    >
      {employeeName || isBulkUpdate ? (
        <ChangeSetLogItem
          testId="employeeName"
          fieldName="Employee"
          oldValue={isBulkUpdate ? 'All' : employeeName}
          asHeader
        />
      ) : null}
      {planName ? (
        <ChangeSetLogItem
          testId="planName"
          fieldName="Plan"
          oldValue={planName}
          asHeader
        />
      ) : null}
      {logs?.map((item) => (
        <ChangeSetLogItem
          key={item?.id}
          testId={`${item?.id}_${item?.fieldName?.replace(regexp.SPACE_SYMBOL, '_')}`}
          fieldName={item?.fieldName}
          oldValue={item?.oldValue}
          newValue={item?.newValue}
        />
      ))}
    </ChangeSetWrapper>
  );
};
